import { render } from "./GlobalLoginPage.vue?vue&type=template&id=0c0e4584&scoped=true"
import script from "./GlobalLoginPage.vue?vue&type=script&lang=js"
export * from "./GlobalLoginPage.vue?vue&type=script&lang=js"

import "./GlobalLoginPage.vue?vue&type=style&index=0&id=0c0e4584&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0e4584"]])

export default __exports__